const GroupedList = require("app/components/lists/DynamicGroupedList");
const PostList = require("app/components/posts/PostList");
const router = require("app/services/router");
const assign = require("object-assign");
const objectFit = require("app/frontend/object-fit");
const debounce = require("app/util/debounce");

class List extends GroupedList {

	static get defaultProps() {
		return assign({}, super.defaultProps, {
			searchPlaceholder: translate("Søg efter blogindlæg..."),
			noItemsText: translate("Der blev ikke fundet nogen blogindlæg."),
			items: []
		});
	}

	get className() {
		return "grouped-list dynamic-grouped-list dynamic-posts-list";
	}

	constructor(props) {
		super(props);

		let activeGroup = 0;

		if (props.activeGroup) {
			if (typeof props.activeGroup === "number") {
				activeGroup = props.activeGroup;
			}
			else {
				for (let i = 0; i < props.items.length; i++) {
					if (props.items[i].guid === props.activeGroup) {
						activeGroup = i;
					}
				}
			}
		}

		this.state = {
			activeGroup: activeGroup,
			items: props.items.length > 0 ? props.items[activeGroup].items : [],
			pagination: props.items.length > 0 ? props.items[activeGroup].pagination : null,
			loading: false
		};

		window.onpopstate = ()=> this.detectBrowserButtons();
	}

	_groupClickListener = (i, item) => {
		return () => {
			let carryOver = this.setVars(1, "page", 1);
			carryOver = this.removeVar("page", carryOver);

			console.log(item.title);

			let curCrumbs = document.getElementsByClassName("breadcrumb-anchor");

			if(item.title === translate("Alle")){
				curCrumbs[curCrumbs.length-1].parentNode.removeChild(curCrumbs[curCrumbs.length-1]);
			} else if (curCrumbs.length === 3) {
              curCrumbs[curCrumbs.length - 1].innerHTML = item.title
              curCrumbs[curCrumbs.length - 1].setAttribute("href", item.link + carryOver);
            } else {

              let clone = curCrumbs[curCrumbs.length - 1].cloneNode(true);

              clone.innerHTML = item.title
              clone.setAttribute("href", item.link + carryOver);

              curCrumbs[curCrumbs.length - 1].parentNode.appendChild(clone);

            }

          window.history.pushState('', '', url = item.link + carryOver);

          if (this.state.activeGroup !== i) {
            if (this.shoudLoadGroup(i)) {
              this.loadGroup(i);
            } else {
              this.setGroup(i);
            }
          }
        };
	};

	endpoint(index, page, search) {
		const group = this.props.items[index];

		let params = {
			category: group.guid,
			$page: page
		};

		if (search && (typeof  search === "string") && (search.length > 0)) {
			params.$search = search;
		}

		return router.route("api.posts.index", null, params);
	}

	onUpdate() {
		objectFit();
	}

	renderList() {
		return (
			<PostList items={this.state.items}/>
		);
	}

	_onPageChange = (page) => {
		let newUrl = this.setVars(page, "page", 1);
		this.setUrl(newUrl);
		this.changePage(page);
	};

	setUrl(newUrl){
		window.history.pushState('', '',url = newUrl);
	}

	removeVar(varName, Url){

		console.log(Url);

		let splitUrl = Url.split('?');
		let variables = [];
		let varSet = false;

		let extras = "";

		if(splitUrl.length >= 2){
			variables = splitUrl[1].split('&');
			variables.sort();
		}

		for (let i = 0; i < variables.length; i++) {
			let variable = variables[i].split("=");

			

			if(variable[0] === varName){
				//do nothing
			} else {

				if(varSet){
					extras += "&";
				}

				extras += variable[0]+"="+variable[1];
				varSet = true;
			}
			
		}
		
		if(varSet){
			extras = "?"+extras;
		}
		return extras;
	}

	setVars(input, varName, negate){

		let Url = window.location.href.split('?');
		let newURL = Url[0];
		let variables = [];
		let varSet = false;
		let varNameSet = false;

		let extras = "";

		if(Url.length >= 2){
			variables = Url[1].split('&');
			variables.sort();
		} else {
			variables = [varName+"="+input];
		}

		for (let i = 0; i < variables.length; i++) {
			let variable = variables[i].split("=");

			

			if(variable[0] === varName){
				variable[1] = input;
			}

			//check if page
			if(variable[0] === "page" && varName != "page"){
				if(variables.length === 1){
					extras = "?"+varName+"="+input;
				}
			} else if (input != negate && varName === variable[0] || varName != variable[0]){

				if(varSet){
					extras += "&";
				}

				extras += variable[0]+"="+variable[1];
				varSet = true;
			}

			if(variable[0] === varName){
				varNameSet = true;
			}
			
		}
		
		if(varSet && varNameSet){
			extras = "?"+extras;
		} else if(varSet){
			extras = "?"+varName+"="+input+"&"+extras;
		}

		return newURL+extras;
	}

	detectBrowserButtons(){
		try{
			let page = window.location.href.split('?')[1].replace("page=",'');
			this.changePage(page);
		} catch(err) {
			this.changePage(1);
		}
	}

	_onSearchInput = debounce(500, () => {
		if (this.shoudLoadGroup(this.state.activeGroup)) {
			this.loadGroup(this.state.activeGroup, 1);
		}
		else {
			this.setGroup(this.state.activeGroup);
		}
		let newUrl = this.setVars(this.searchInput.value, "search", "");
		this.setUrl(newUrl);
	});

}

module.exports = List;
